export default "__VITE_ASSET__CRE8JjCF__"